import type { MinimalSubscriptionResponse } from '@talos/kyoko';
import { useMemo } from 'react';
import { map, type Observable } from 'rxjs';
import type { PriceGridEntity } from '../PriceGridEntity';
import type { PriceGridExpandRows, PriceGridSourceItem } from '../types';

export function usePriceGridDataObservable<TSource extends PriceGridSourceItem>({
  sourceObservable,
  filterSourceItems,
  expandRows,
}: {
  sourceObservable: Observable<MinimalSubscriptionResponse<TSource>>;
  filterSourceItems: (sourceItems: TSource[]) => TSource[];
  expandRows: PriceGridExpandRows<TSource>;
}) {
  return useMemo(
    () =>
      sourceObservable.pipe(
        map(json => {
          const data = filterSourceItems(json.data).flatMap(sourceItem => expandRows(sourceItem));
          return {
            ...json,
            data,
          } satisfies MinimalSubscriptionResponse<PriceGridEntity>;
        })
      ),
    [expandRows, filterSourceItems, sourceObservable]
  );
}
